import React, { useContext } from "react";
import { DataTable } from "@MASTER";
import useLogics from "./logics";
import { InvoiceEndpoints, downloadPods } from "@INVOICES";
import { FiltersContext, AuthContext } from "@CONTEXTS";
import { useGET } from "@API2";
import { Button, message } from "antd";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import "dayjs/locale/tr"; // Türkçe locale
dayjs.locale("tr");

const Table = () => {
  const logics = useLogics();
  const { info } = useContext(AuthContext);
  const { pagination, setPageAndLimit, filters } = useContext(FiltersContext);
  const { data, loading, mutate } = useGET(
    `${InvoiceEndpoints.pods}?`,

    filters
      ? `page=${pagination.page}&limit=${pagination.limit}&invoiceType=${
          filters.invoiceType ? filters.invoiceType : ""
        }&search=${filters.search ? filters.search : ""}&startDate=${
          filters.startDate ? filters.startDate : ""
        }&endDate=${filters.endDate ? filters.endDate : ""}`
      : false
  );
  const exportExcel = async () => {
    try {
      if (!info.authorities.includes("DOWNLOAD_PODS")) {
        return message.error(
          "Fatura bilgisi indirme yetkiniz bulunmamaktadır!"
        );
      }
      const response = await downloadPods(filters); // API endpointine göre değiştir
      const allData = response.rows || [];

      if (allData.length === 0) return;

      const dataToExport = allData.map((row) => ({
        "Belge Numarası": row.invoice_number || "",
        "İşlem Tarihi":
          row?.payment_date && dayjs(row.payment_date).isValid()
            ? dayjs(row.payment_date).format("DD MMMM YYYY")
            : "-",
        "Vade Tarihi":
          row?.net_due_date && dayjs(row.net_due_date).isValid()
            ? dayjs(row.net_due_date).format("DD MMMM YYYY")
            : "-",
        Tutar:
          row?.amount != null
            ? `${new Intl.NumberFormat("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(row.amount))} ₺`
            : "-",
        Durum: row?.payment_status || "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Tüm Kayıtlar");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "Tahsilatlı Gönderi Gelirleri.xlsx");
    } catch (error) {
      console.error("Excel verisi alınamadı:", error);
    }
  };
  return (
    <div>
      <div style={{ float: "right" }}>
        <Button
          icon={<AiOutlineCloudDownload />}
          onClick={() => {
            exportExcel();
          }}
        >
          İndir
        </Button>
      </div>
      <DataTable
        name="Fatura Listesi"
        {...logics}
        dataSource={data?.rows || []}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSizeOptions: [25, 50, 100, 250],
          total: data?.totalRowCounts,
          pageSize: pagination?.limit,
          current: pagination?.page,
          onChange: (page, limit) => {
            setPageAndLimit({ page, limit });
          },
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} arası gösteriliyor • Toplam ${total} kayıt`,

          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        bordered
        mutate={mutate}
        tag="Veriler her gece güncellenir. Gün içinde yapılan değişiklikler bir
              sonraki gün yansıyabilir."
      />
    </div>
  );
};

export default Table;
